import CogIcon from "../../Icons/Cog";
import LinkCard from "../../components/Reusable/LinkCard";
import StatusIcon from "../../Icons/StatusIcon";


const Settings = () => {
  const navigation: any = [
    
    {
      name: "Country",
      href: "/country",
      icon: StatusIcon,
    },
    {
      name: "State",
      href: "/state",
      icon: StatusIcon,
    },
    {
      name: "District",
      href: "/district",
      icon: StatusIcon,
    },
    {
      name: "City",
      href: "/city",
      icon: StatusIcon,
    },
    {
      name: "Status",
      href: "/status-settings",
      icon: StatusIcon,
    },
    
    {
      name: "Product Type",
      href: "/product-type",
      icon: StatusIcon,
    },
    {
      name: "Branch",
      href: "/branch",
      icon: StatusIcon,
    },
    {
      name: "Area Covered",
      href: "/area-covered",
      icon: StatusIcon,
    },
    {
      name: "Rate Template",
      href: "/delivery-charge-template",
      icon: StatusIcon,
    },
    {
      name: "Warehouse",
      href: "/warehouse",
      icon: StatusIcon,
    },
    {
      name: "Reference Type",
      href: "/reference-type",
      icon: StatusIcon,
    },
    {
      name: "Payment Method",
      href: "/payment-method",
      icon: StatusIcon,
    },
    {
      name: "Service Type",
      href: "/service-type",
      icon: StatusIcon,
    },
    {
      name: "Vehicle Category",
      href: "/vehicle-category",
      icon: StatusIcon,
    },
    {
      name: "Vehicle type",
      href: "/vehicle-type",
      icon: StatusIcon,
    },
    {
      name: "Vehicle",
      href: "/vehicle",
      icon: StatusIcon,
    },
    {
      name: "Other",
      href: "/other",
      icon: StatusIcon,
    },
  ];


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 uppercase font-extrabold items-center">
        <CogIcon />
        <span className="text-[#5E5757] font-bold text-xl">Settings</span>
      </div>
      <div className={"columns-1 md:columns-3 mt-6 w-full"}>
        {navigation?.map((item: any, index: number) => (
          <LinkCard
            key={index}
            label={item?.name}
            href={item?.href}
            icon={<item.icon color={"var(--primary)"} />}
          />
        ))}
      </div>
    </>
  );
};

export default Settings;
